// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
}

.library-item {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
}
.library-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.library-item h3 {
  font-size: 20px;
  font-weight: 600;
  color: #212427;
  margin: 0 0 8px 0;
  line-height: 1.4;
}
.library-item p {
  margin: 0;
  color: #333;
  line-height: 1.8;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/thirdpartyliabraries/thirdpartyliabraries.component.scss"],"names":[],"mappings":"AAGA;EACE,cAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAFF;;AAMA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AAHF;AAKE;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,SAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AALJ","sourcesContent":["// Styles are now handled by the legal-center-layout component\n// This file can be used for page-specific overrides if needed\n\n:host {\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n// Library item styling to match legal page style\n.library-item {\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #e0e0e0;\n\n  &:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n\n  h3 {\n    font-size: 20px;\n    font-weight: 600;\n    color: #212427;\n    margin: 0 0 8px 0;\n    line-height: 1.4;\n  }\n\n  p {\n    margin: 0;\n    color: #333;\n    line-height: 1.8;\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
